import { useLocale } from '../../../../hooks/useLocale';
import { TOnlineBank } from '../OpenBanking.types';
import BankListViewDE from './BankListViewDE';
import BankListViewUK from './BankListViewUK';

const BankListView = ({
  banks,
  onSearch,
  searchTerm,
  onBankSelect,
  ableToShareLink,
}: {
  onSearch: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBankSelect: (bank: TOnlineBank) => void;
  banks: TOnlineBank[];
  searchTerm: string;
  ableToShareLink: boolean;
}) => {
  const { isDE } = useLocale();

  if (isDE) {
    return (
      <BankListViewDE
        banks={banks}
        onSearch={onSearch}
        searchTerm={searchTerm}
        onBankSelect={onBankSelect}
      />
    );
  }

  return (
    <BankListViewUK
      banks={banks}
      onSearch={onSearch}
      searchTerm={searchTerm}
      onBankSelect={onBankSelect}
      ableToShareLink={ableToShareLink}
    />
  );
};

export default BankListView;
